import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route, Navigate} from 'react-router-dom'

import './index.css';
import Navbar from './components/navbar/Navbar.js';
import Home from './pages/home/Home';
import Carte from './pages/carte/Carte';
import reportWebVitals from './reportWebVitals';
import Footer from './components/footer/Footer';

ReactDOM.render(
  <React.StrictMode>
    <Navbar />
    <BrowserRouter>
      <Routes>
        <Route path="/accueil" element={<Home />} />
        <Route path="/carte" element={<Carte />} />
        <Route path="/" element={<Navigate to ="/accueil" />}/>
      </Routes>
    </BrowserRouter>
    <Footer/>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
